module.exports = __webpack_public_path__ + "static/media/damage.3c5522b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/driverpolicy-images/damage.png
// module id = 1328
// module chunks = 0